import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import StatusAction from '~/components/ui/StatusAction';
import { useReviewStats } from '~/hooks/userReviewStats';
import {
  CommentV2,
  DISCUSSION_STATUS_APPROVED,
  DISCUSSION_STATUS_REJECTED,
  DISCUSSION_STATUS_UNMODERATED,
  DiscussionStatus,
} from '~/lib/discussions/types';
import { useCommentV2 } from '~/lib/discussions/useCommentV2';

interface DiscussionActionsProps {
  isModerator: boolean;
  status: DiscussionStatus;
  comment: CommentV2;
  mutateComment?: () => void;
}

function DiscussionActions({
  isModerator,
  status,
  comment,
  mutateComment,
}: Readonly<DiscussionActionsProps>) {
  const { mutateReviewStats } = useReviewStats(comment.deal_id);
  const { approve, unapprove, deny, undeny } = useCommentV2(
    comment,
    mutateComment ?? (() => {}),
    mutateReviewStats,
  );

  if (!isModerator) {
    return (
      <div className="w-full">
        <StatusAction
          label={
            status === DISCUSSION_STATUS_APPROVED ? 'Approved' : 'Declined'
          }
          variant={status === DISCUSSION_STATUS_APPROVED ? 'dollar' : 'brick'}
          faIcon={
            status === DISCUSSION_STATUS_APPROVED
              ? faCheckCircle
              : faTimesCircle
          }
        />
      </div>
    );
  }

  return (
    <div className="flex w-full items-center gap-4">
      {status !== DISCUSSION_STATUS_REJECTED && (
        <div className="grow">
          <StatusAction
            label={
              status === DISCUSSION_STATUS_APPROVED ? 'Approved' : 'Approve'
            }
            variant="dollar"
            undoLabel="Undo"
            faIcon={faCheckCircle}
            enableAction={status === DISCUSSION_STATUS_UNMODERATED}
            onActionClick={approve}
            enableUndo={status === DISCUSSION_STATUS_APPROVED}
            onUndoClick={unapprove}
          />
        </div>
      )}
      {status !== DISCUSSION_STATUS_APPROVED && (
        <div className="grow">
          <StatusAction
            label={
              status === DISCUSSION_STATUS_REJECTED ? 'Declined' : 'Decline'
            }
            variant="brick"
            undoLabel="Undo"
            faIcon={faTimesCircle}
            enableAction={
              isModerator && status === DISCUSSION_STATUS_UNMODERATED
            }
            onActionClick={deny}
            enableUndo={isModerator && status === DISCUSSION_STATUS_REJECTED}
            onUndoClick={undeny}
          />
        </div>
      )}
    </div>
  );
}

export default DiscussionActions;
